import { Editor, TLShapeId } from '@tldraw/tldraw'
import { ExportFormat, ExportOptions, exportToBlob } from './exportDesign'
import dayjs from 'dayjs'

export async function exportAs(
  editor: Editor,
  ids: TLShapeId[],
  format: ExportFormat,
  opts = {} as Partial<ExportOptions>,
) {
  const timestamp = dayjs().format('YYYY-MM-DD HH.mm.ss')
  const name = `Design ${timestamp}.${format}`
  const blob = await exportToBlob(editor, ids, format, opts)
  return new File([blob], name, { type: blob.type })
}
